const initialState = () => ({
  isOpened: false,
  error: null,
  padVisit: {}
});

const ACTION_KEY = 'PAD_CREATOR_SUSPEND_VISIT_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return {
        ...state,
        isOpened: true,
        padVisit
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
